import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { verifyToken } from '../services/api';

const PrivateRoute = ({ children, requiredRole = null }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const checkAuth = async () => {
      // Déterminer quel token utiliser selon la route
      const isAdminRoute = location.pathname.startsWith('/admin');
      const isRecolteurRoute = location.pathname.startsWith('/recolteur');
      const isGererRoute = location.pathname.startsWith('/gerer');
      const isFamilleRoute = location.pathname.startsWith('/famille');
      const isFinancesRoute = location.pathname.startsWith('/finances');
      
      const token = isAdminRoute 
        ? localStorage.getItem('admin_token')
        : isRecolteurRoute
        ? localStorage.getItem('recolteur_token')
        : isGererRoute
        ? localStorage.getItem('gerer_token')
        : isFamilleRoute
        ? localStorage.getItem('famille_token')
        : isFinancesRoute
        ? localStorage.getItem('finances_token')
        : localStorage.getItem('admin_token') || localStorage.getItem('recolteur_token') || localStorage.getItem('gerer_token') || localStorage.getItem('famille_token') || localStorage.getItem('finances_token');
      
      if (!token) {
        setIsAuthenticated(false);
        setLoading(false);
        return;
      }

      try {
        const response = await verifyToken();
        const admin = response.data.admin;
        
        // Vérifier le rôle si requis
        if (requiredRole && admin.role !== requiredRole) {
          if (isAdminRoute) {
            localStorage.removeItem('admin_token');
            localStorage.removeItem('admin_user');
          } else if (isRecolteurRoute) {
            localStorage.removeItem('recolteur_token');
            localStorage.removeItem('recolteur_user');
          } else if (isGererRoute) {
            localStorage.removeItem('gerer_token');
            localStorage.removeItem('gerer_user');
          } else if (isFamilleRoute) {
            localStorage.removeItem('famille_token');
            localStorage.removeItem('famille_user');
          } else if (isFinancesRoute) {
            localStorage.removeItem('finances_token');
            localStorage.removeItem('finances_user');
          }
          setIsAuthenticated(false);
          setLoading(false);
          return;
        }
        
        setIsAuthenticated(true);
      } catch (error) {
        if (isAdminRoute) {
          localStorage.removeItem('admin_token');
          localStorage.removeItem('admin_user');
        } else if (isRecolteurRoute) {
          localStorage.removeItem('recolteur_token');
          localStorage.removeItem('recolteur_user');
        } else if (isGererRoute) {
          localStorage.removeItem('gerer_token');
          localStorage.removeItem('gerer_user');
        } else if (isFamilleRoute) {
          localStorage.removeItem('famille_token');
          localStorage.removeItem('famille_user');
        } else if (isFinancesRoute) {
          localStorage.removeItem('finances_token');
          localStorage.removeItem('finances_user');
        }
        setIsAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, [requiredRole, location.pathname]);

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
        <p>Chargement...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Rediriger vers la bonne page de login selon la route
    if (location.pathname.startsWith('/admin')) {
      return <Navigate to="/login-admin" replace />;
    } else if (location.pathname.startsWith('/recolteur')) {
      return <Navigate to="/login-recolteur" replace />;
    } else if (location.pathname.startsWith('/gerer')) {
      return <Navigate to="/login-gerer" replace />;
    } else if (location.pathname.startsWith('/famille')) {
      return <Navigate to="/login-famille" replace />;
    } else if (location.pathname.startsWith('/finances')) {
      return <Navigate to="/login-finances" replace />;
    }
    return <Navigate to="/login-recolteur" replace />;
  }

  return children;
};

export default PrivateRoute;


